/**
 * Market Switcher Modal - Custom element (like cart-drawer)
 * Hermès-style LOCATION panel - smooth slide-in from right
 */
class MarketSwitcherModal extends HTMLElement {
  constructor() {
    super();
    this.activeElement = null;

    this.querySelector('.market-switcher-modal__overlay')?.addEventListener('click', this.close.bind(this));
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

    this.bindTriggers();
    this.bindRegionAccordion();
    this.bindCountryLinks();
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    setTimeout(() => {
      this.classList.add('animate', 'active');

      const panel = this.querySelector('.market-switcher-modal__panel');
      const closeBtn = this.querySelector('.market-switcher-modal__close');
      if (typeof trapFocus === 'function') {
        trapFocus(panel, closeBtn);
      }
    });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(this.activeElement);
    }
    document.body.classList.remove('overflow-hidden');
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  expandFirstRegion() {
    const firstRegion = this.querySelector('.market-switcher-region');
    if (firstRegion) {
      const header = firstRegion.querySelector('.market-switcher-region__header');
      if (header) {
        firstRegion.setAttribute('data-expanded', 'true');
        header.setAttribute('aria-expanded', 'true');
      }
    }
  }

  bindTriggers() {
    document.querySelectorAll('[data-market-switcher-trigger]').forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        if (trigger.hasAttribute('data-close-drawer')) {
          const menuDrawer = document.getElementById('menu-drawer');
          const backdrop = document.querySelector('.menu-drawer__backdrop');
          const toggleButton = document.querySelector('.menu-drawer-toggle');
          if (menuDrawer?.classList.contains('is-open')) {
            menuDrawer.classList.remove('is-open');
            backdrop?.classList.remove('is-visible');
            toggleButton?.setAttribute('aria-expanded', 'false');
            menuDrawer.setAttribute('aria-hidden', 'true');
            document.body.style.overflow = '';
          }
        }
        this.open(trigger);
      });
    });
  }

  bindRegionAccordion() {
    this.querySelectorAll('.market-switcher-region__header').forEach((header) => {
      header.addEventListener('click', () => this.toggleRegion(header));
    });
  }

  toggleRegion(header) {
    const region = header.closest('.market-switcher-region');
    const list = region?.querySelector('.market-switcher-region__list');
    const isExpanded = region?.getAttribute('data-expanded') === 'true';

    if (isExpanded) {
      region.setAttribute('data-expanded', 'false');
      header.setAttribute('aria-expanded', 'false');
    } else {
      region.setAttribute('data-expanded', 'true');
      header.setAttribute('aria-expanded', 'true');
    }
  }

  bindCountryLinks() {
    this.querySelectorAll('.market-switcher-region__link[data-country-code]').forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const countryCode = link.dataset.countryCode;
        if (countryCode) {
          const form = this.querySelector('#MarketSwitcherForm');
          const countryInput = form?.querySelector('input[name="country_code"]');
          if (form && countryInput) {
            countryInput.value = countryCode;
            form.submit();
          }
        }
      });
    });
  }
}

customElements.define('market-switcher-modal', MarketSwitcherModal);
